var slug = function(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();
  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
  var to   = "aaaaaeeeeeiiiiooooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes
  return str;
};

var recursiveUpdate = function(categories, adminResource) {
  try {
    for (var i = 0; i < categories.length; i++) {
      const category = categories[i];
      category.order = i;
      adminResource.updateCategory(category.id, category);
      if (category.children && category.children.length){
        recursiveUpdate(category.children, adminResource);
      }
    }
  } catch (error) {
    console.log(error)
  }
}

angular.module('admin.categories.tree', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'services.formErrors',
  'resources.AdminCategory'
])
.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.categories.tree', {
      url: '/tree',
      title: 'Manage Categories',
      middlewares: ['isAdmin'],
      views: {
        'main@': {
          template: require('./admin-categories-tree.tpl.html'),
          controller: 'CategoriesTreeCtrl'
        }
      }
    });
}])

.controller('CategoriesTreeCtrl',
  ["$scope", "$route", "$location", "$log", "$uibModal", "utility", "AdminCategory", "adminResource", "$timeout", function($scope, $route, $location, $log, $uibModal, utility, AdminCategory, adminResource, $timeout){

    // local var
    var deserializeData = function(data){
      $scope.categories = data;
    };

    $scope.treeOptions = {
      dropped: function(e) {
        var destIndex = e.dest.index;
        var sourceIndex = e.source.index;
        var destParentValue = e.dest.nodesScope.$nodeScope ? e.dest.nodesScope.$nodeScope.$modelValue : {};
        var sourceParentValue = e.source.nodesScope.$nodeScope ? e.source.nodesScope.$nodeScope.$modelValue : {};

        //check if position is changed
        if ((destIndex === sourceIndex) && _.isEqual(destParentValue, sourceParentValue)) {
          return console.log('no changes');
        }

        //get the changes
        var parent_path = destParentValue.path || '/';
        
        var order = e.source.nodeScope.$modelValue.order;
        var id = e.source.nodeScope.$modelValue._id;
        var prevNode = e.dest.nodesScope.$modelValue[destIndex - 1];
        var nextNode = e.dest.nodesScope.$modelValue[destIndex + 1];
        var destcat= null;
        if (prevNode) {
          order = prevNode.order + 1;
          destcat = prevNode;
        }
        else if (!prevNode && nextNode) {
          order = nextNode.order - 1;
          destcat = nextNode;
        }

        var ppath = e.source.nodeScope.$modelValue.path.split('/').filter(Boolean);
        ppath.pop();

        var changes = {
          sefriendly: e.source.nodeScope.$modelValue.sefriendly,
          parent: '/' + ppath.join('/'),
          dest: parent_path,
          order: order,
          destcat: destcat
        };
        
        
        var parent_path2 = destParentValue.path || '';
        /*adminResource.updateCategoryPosition(id, changes).then(function(result) {
          e.source.nodeScope.$modelValue.order = changes.order;
          e.source.nodeScope.$modelValue.sefriendly = changes.sefriendly;
          e.source.nodeScope.$modelValue.parent = changes.parent;
          e.source.nodeScope.$modelValue.path = parent_path2 + '/' + changes.sefriendly;
          e.source.nodeScope.$modelValue.view_subcat = changes.view_subcat;
        });*/

        /* Update all order field fixed */
        
        try {
          $timeout(function (){
            recursiveUpdate($scope.categories, adminResource);
          }, 1000);
        } catch (error) {
          console.log("setTimeout error:", error)
        }
      }
    };

    $scope.toggleNode = function(node) {
      var modelValue = node.$nodeScope.$modelValue;
      var pathLength = modelValue.path.split('/').filter(Boolean).length;
      var objPath = 'children' + (new Array(pathLength).join('.[0].children'));
      var children = {};

      adminResource.getCategoriesTree({path: modelValue.path, depth: 2}).then(function(result) {
        if (!result.length) {
          return;
        }

        result = result[0];
        modelValue.children = _.get(result, objPath);
        node.toggle();
      });
    };

    var generateCategoryOptions = function(items, container) {
      items.forEach(function(item) {
        if (!item.path) {
          return;
        }
        var depth = item.path.split('/').filter(Boolean).length;
        var indent = (new Array(5)).join(String.fromCharCode(160));
        container.push({
          _id: item._id,
          path: item.path,
          sefriendly: item.sefriendly,
          parent: item.parent,
          parent_id: item.parent_id,
          name: item.name,
          view_subcat: item.view_subcat,
          _name: (new Array(depth)).join(indent) + item.name
        });
        if (item.children) {
          generateCategoryOptions(item.children, container);
        }
      });
      return container;
    };


    $scope.addCategory = function() {
      //show modal
      var dialog = $uibModal.open({
        templateUrl: 'add_category.tpl.html',
        controller: 'AddCategoryCtrl',
        resolve: {
          options: function() {
            var options = [];
            return AdminCategory.getTree().$promise.then(function(data) {
              generateCategoryOptions(data, options);
              return options;
            });
          }
        }
      });
      dialog.result.then(function handleClose(result) {
        dialog.close();
        dialog = null;
        AdminCategory.getTree({path: '/', depth: 2}, function (categories) {
          //initialize $scope variables
          deserializeData(categories);
        });
      }, function handleDismiss() {
        dialog = null;
      });
    };

    $scope.editItem = function(node) {
      var modelValue = node.$nodeScope.$modelValue;

      //show modal
      var dialog = $uibModal.open({
        templateUrl: 'edit_category.tpl.html',
        controller: 'EditCategoryCtrl',
        resolve: {
          data: function() {
            return modelValue;
          },
          options: function() {
            var options = [];
            return AdminCategory.getTree().$promise.then(function(data) {
              generateCategoryOptions(data, options);
              return options;
            });
          }
        }
      });
      dialog.result.then(function handleClose(result) {
        dialog.close();
        dialog = null;
        if (!result) {
          return node.remove();
        }
        node.$nodeScope.$modelValue.name =  result.name;
        node.$nodeScope.$modelValue.path =  result.parent +'/'+result.sefriendly;
        node.$nodeScope.$modelValue.sefriendly =  result.sefriendly;
        node.$nodeScope.$modelValue.view_subcat =  result.view_subcat;
        AdminCategory.getTree({path: '/', depth: 2}, function (categories) {
          //initialize $scope variables
          deserializeData(categories);
        });
      }, function handleDismiss() {
        dialog = null;
      });
    };


    AdminCategory.getTree({path: '/', depth: 2}, function (categories) {
      //initialize $scope variables
      deserializeData(categories);
    });
  }])

.controller('AddCategoryCtrl',
  ["$scope", "$uibModalInstance", "$log", "AdminCategory", "options", "formErrors", function($scope, $uibModalInstance, $log, AdminCategory, options, formErrors) {

    $scope.options = options;
    $scope.hasEditedName = false;
    $scope.rootUrl = '';
    $scope.data = {
      name: '',
      sefriendly: '',
      parent: '',
      view_subcat: false
    };

    $scope.changedName = function() {
      if (!$scope.hasEditedName) {
        $scope.data.sefriendly = slug($scope.data.name || '');
      }
    };

    $scope.editedName = function() {
      if ($scope.data.sefriendly !== '') {
        $scope.hasEditedName = true;
      }
    };

    $scope.editSefriendly = function() {
      $scope.showSefriendly = true;
    };

    $scope.saveSefriendly = function() {
      $scope.showSefriendly = false;
    };

    $scope.changedParent = function() {
      $scope.rootUrl = location.href.replace(location.pathname, '');
      if ($scope.data.parent) {
        $scope.rootUrl += $scope.data.parent.path;
      }

      $scope.rootUrl += '/';
    };

    $scope.save = function () {
      var view_subcat= 2;
      if($scope.data.view_subcat){
        view_subcat = 1;
      }
      // console.log( '>>>', $scope.data );
      var parentPath = $scope.data.parent ? $scope.data.parent.path : '/';
      var parent_id = $scope.data.parent ? $scope.data.parent.parent_id : [];
      var dataCopy = {
        name: $scope.data.name,
        parent: parentPath || '/',
        parent_id: parent_id,
        sefriendly: $scope.data.sefriendly,
        view_subcat: view_subcat
      };
      AdminCategory.save(dataCopy, function(result) {
        $uibModalInstance.close(result);
      }, formErrors.growlErrors);
    };

    $scope.changedParent();

}])


.controller('EditCategoryCtrl',
  ["$scope", "$uibModalInstance", "AdminCategory", "growl", "options", "data", "formErrors", "APP_IMG_URLS", "Upload", function($scope, $uibModalInstance, AdminCategory, growl, options, data, formErrors, APP_IMG_URLS, Upload) {
    var parent = '';
    var parentPath = data.path.substring(0, data.path.lastIndexOf("/"));
    var sefriendly = data.path.substring(data.path.lastIndexOf("/")).replace('/','');
    var view_subcatedit =false;
    options.forEach(function(item) {
      if (item.path === parentPath) {
        parent = item;
      }
    });
    if(data.view_subcat === 1){
        view_subcatedit = true;
      }

    $scope.imgUrl = APP_IMG_URLS.base;
    $scope.options = options;
    $scope.hasEditedName = true;
    $scope.rootUrl = '';
    // console.log( '>>', data );
    $scope.data = {
      _id: data._id,
      id: data.id,
      old_path: data.path,
      name: data.name,
      sefriendly: sefriendly,
      parent: parent,
      parent_id: data.parent_id,
      view_subcat: view_subcatedit,
      image: data.image
    };
    $scope.changedName = function() {
      if (!$scope.hasEditedName) {
        $scope.data.sefriendly = slug($scope.data.name || '');
      }
    };
    $scope.editedName = function() {
      if ($scope.data.sefriendly !== '') {
        $scope.hasEditedName = true;
      }
    };
    $scope.editSefriendly = function() {
      $scope.showSefriendly = true;
    };
    $scope.saveSefriendly = function() {
      $scope.showSefriendly = false;
    };
    $scope.changedParent = function() {
      $scope.rootUrl = location.href.replace(location.pathname, '');
      if ($scope.data.parent) {
        $scope.rootUrl += $scope.data.parent.path;
      }

      $scope.rootUrl += '/';
    };
    $scope.save = function () {
      var view_subcateditsave= 2;
      if($scope.data.view_subcat){
        view_subcateditsave = 1;
      }
      var parentPath = $scope.data.parent ? $scope.data.parent.path : '/';
      var dataCopy = {
        _id: data._id,
        id: $scope.data.id,
        name: $scope.data.name,
        old_path: $scope.data.old_path,
        image: $scope.data.image,
        parent: parentPath || '/',
        parent_id: $scope.data.parent_id || '',
        path: parentPath + '/' + $scope.data.sefriendly,
        sefriendly: $scope.data.sefriendly,
        view_subcat: view_subcateditsave
      };
      AdminCategory.update(dataCopy, function(result) {
        $uibModalInstance.close(result);
      }, formErrors.growlErrors);
    };
    $scope.delete = function() {
      if (!confirm('Deleting parent will delete all children. Are you sure you want to continue?')) {
        return;
      }
      AdminCategory.delete({id: data._id}, function(result) {
        $uibModalInstance.close(null);
      }, formErrors.growlErrors);
    };

    $scope.$watch('file', function (file) {
      if (!file) return;
      $scope.upload(file);
    });

    $scope.upload = function (file) {
      console.log('>>>', file.size);
      $scope.uploading = true;
      $scope.image = file;
      Upload.upload({
        url: '/api/articles/upload',
        data: {file: file}
      }).then(function (resp) {
        $scope.uploading = false;
        $scope.data.image = resp.data.filename;
      }, function (resp) {
        $scope.uploading = false;
        $scope.thumbnail = null;
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        //console.log('progress: ' + progressPercentage + '% ' + evt.config.groups.file.name);
      });
    };


    $scope.changedParent();
  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/categories/admin-categories-tree.js